import { render, staticRenderFns } from "./casebanner.vue?vue&type=template&id=8ad595a8&"
import script from "./casebanner.vue?vue&type=script&lang=js&"
export * from "./casebanner.vue?vue&type=script&lang=js&"
import style0 from "./casebanner.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports